import React from 'react';
import { GeckoLabel, GECKO_CONSTS } from 'ui';
import './index.scss';

const CountLabel = ({ count }) => (
  <div className="count-label-container">
    <div className="count-label">{count}</div>
  </div>
);

const OpportunityCard = ({
  handleSelectOpportunity,
  index,
  response_name,
  sample,
  count,
  closest_response,
  selectedOpportunity,
}) => {
  const isActive = selectedOpportunity?.closest_response === closest_response;
  return (
    <li
      aria-label={`Suggested opportunity - ${response_name}`}
      className={`SuggestedOpportunities-card${isActive ? ' active' : ''}`}
      onClick={() => handleSelectOpportunity(index, closest_response)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          handleSelectOpportunity(index, closest_response);
        }
      }}
      tabIndex="0"
      role="button"
    >
      <div className="opportunity-details-container">
        <h4>{response_name}</h4>
        <span>{sample}</span>
      </div>
      <CountLabel count={count} />
    </li>
  );
};

const SuggestedOpportunities = ({
  handleSelectOpportunity,
  opportunities,
  selectedOpportunity,
}) => {
  return (
    <div className="SuggestedOpportunities">
      <h2 className="header-title">Suggested Opportunities</h2>
      <ul className="SuggestedOpportunities-card-container">
        {opportunities.map((opportunity, index) => (
          <OpportunityCard
            key={opportunity.closest_response}
            handleSelectOpportunity={handleSelectOpportunity}
            index={index}
            selectedOpportunity={selectedOpportunity}
            {...opportunity}
          />
        ))}
      </ul>
    </div>
  );
};

export default SuggestedOpportunities;
